module.exports = __webpack_public_path__ + "static/media/notifications.d77c67f2.svg";